/**
 * Booking email helpers — sends booking confirmation to consultant
 * and session reminder to client via /api/email/booking-notifications.
 */

export interface BookingEmailParams {
  consultantEmail: string;
  clientEmail: string;
  consultantName: string;
  clientName: string;
  sessionDate: string;
  sessionTime: string;
  duration: string;
  sessionTopic: string;
  sessionNotes?: string;
  consultantEarnings: number;
}

/**
 * Sends:
 *  1. Booking confirmation email → consultant
 *  2. Session reminder email → client
 */
export async function sendBookingEmails(params: BookingEmailParams): Promise<void> {
  try {
    const res = await fetch('/api/email/booking-notifications', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        consultant_email: params.consultantEmail,
        client_email: params.clientEmail,
        consultant_name: params.consultantName,
        client_name: params.clientName,
        session_date: params.sessionDate,
        session_time: params.sessionTime,
        duration: params.duration,
        session_topic: params.sessionTopic,
        session_notes: params.sessionNotes ?? '',
        consultant_earnings: params.consultantEarnings,
      }),
    });

    if (!res.ok) {
      const err = await res.json();
      console.error('[BookingEmails] Failed to send:', err);
    }
  } catch (err) {
    console.error('[BookingEmails] Network error:', err);
  }
}
